import { useEffect, useState } from 'react';
import type { Appearance } from './types.js';

const STORAGE_KEY = 'conductor.appearance.v1';

const DEFAULT_APPEARANCE: Appearance = {
  direction: 'signal',
  density: 'regular',
  communityPreview: false,
};

function loadAppearance(): Appearance {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_APPEARANCE;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_APPEARANCE, ...parsed };
  } catch {
    return DEFAULT_APPEARANCE;
  }
}

export function useAppearance(): [Appearance, (a: Appearance) => void] {
  const [appearance, setAppearanceState] = useState<Appearance>(loadAppearance);

  function setAppearance(next: Appearance) {
    setAppearanceState(next);
  }

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(appearance));
  }, [appearance]);

  return [appearance, setAppearance];
}
